import { KkmhImageFormat } from "./sdk.imageFormat";

//工具类
class TOOLS extends KkmhImageFormat{
    constructor(){
        super();
        const href = window.location.href;
        const env = /kuaikanmanhua.com/.test(href) ? "pro":"dev";
        this.env = env;
    }

    //判断是否是数组  返回
    isArray(ary){
        if(!ary){ return false }
        let val = typeof ary === "object" && !isNaN(ary.length);
        return val;
    }
          
    //判断是否是对象
    isObject(obj){
        if(!obj){ return false }
        let val = typeof obj === "object" && isNaN(obj.length);
        return val;
    }

    //判断是否为函数
    isFunction(fn){
        if(!fn){ return false }
        let val = typeof fn === "function";
        return val;
    }
    
    //判断是否为有效数字
    isNumber(value) {
        if( !value && !(value===0||value==="0") ){ return false }
        value = Number(value);
        return typeof value === "number" && !isNaN(value);
    }
    
    //判断是否为字符串
    isString(str){ 
        return (typeof str=="string")&&str.constructor==String; 
    } 

    //判断是否为布尔
    isBoolean(bool){
        return typeof bool === "boolean";
    }
    
    //判断是否为json数据
    isJson(str) {
        if (typeof str === "string") {
            try {
                let obj = JSON.parse(str);
                if(typeof obj == "object" && obj ){
                    return true;
                }else{
                    return false;
                }
            } catch (error) {
                return false;
            }
        }else{
            return false;
        }
    }

    //判断是否为有效的url
    isUrl(val){
        let reg = /^(http|https):\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\’:+!]*([^<>\"\"])*$/;
        if(this.isString(val)){
            return reg.test(val);
        }else{
            return false;
        }
    }

    //获取url 参数
    urlValue(key) {
        var ret = {};
        var url = window.location.href;
        var pat = /([^?=&|#]+)=([^?=&|#]+)/g;
        url.replace(pat, function() {
            ret[arguments[1]] = arguments[2];
        });
        return ret[key] ? ret[key] : ret;
    }

    //升级版获取url/字符串?后的参数
    extendUrlValue({url="",key}={}){
        let ret = {};
        let pat = /([^?=&|#]+)=([^?=&|#]+)/g;
        url = url ? url : window.location.href;
        url.replace(pat, function() {
            ret[arguments[1]] = arguments[2];
        });
        return ret[key] ? ret[key] : ret;
    }

    /** 
     * * setCookie 写入Cookie 
     * @name  写入的Cookie名称  类型:字符
     * @value 写入的value  类型:字符&数字
     * @expires 写入的Cookie有效期  默认:24小时
     * @path 生效的路径  类型:字符 默认 /
     * 
     * **/
    setCookie(name, value, expires, path, domain) {
        if (typeof expires === "undefined") {
            expires = new Date(new Date().getTime() + 1000 * 60 * 60 * 24);
        }
        document.cookie = name + "=" + value + (expires ? ";expires=" + expires.toGMTString() : "") + (path ? ";path=" + path : ";path=/") + (domain ? ";domain=" + domain : "");
    }

    //获取Cookie
    getCookie(name) {
        var arr = document.cookie.match(
            new RegExp("(^| )" + name + "=([^;]*)(;|$)")
        );
        if (arr !== null) {
            return unescape(arr[2]);
        }
        return null;
    }

    //清处Cookie
    clearCookie(name, path, domain) {
        if (this.getCookie(name)) {
            document.cookie = name + "=" + (path ? "; path=" + path : "; path=/") + (domain ? "; domain=" + domain : "") + ";expires=Fri, 02-Jan-1970 00:00:00 GMT";
        }
    }

    //清楚所有的cookie
    clearAllCookie() {
        var date = new Date();
        date.setTime(date.getTime() - 10000);
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        if (keys) {
            for (var i = keys.length; i--; ) {
                this.clearCookie(keys[i]);
            }
        }
    }

    /**
     * * localStoreSet 总容量5M
     * 存入缓存，支持字符串类型、json对象的存储
     * 页面关闭后依然有效 ie7+都有效
     * @ param  类型String   key                缓存key       默认值 ''
     * @ param  类型String   val                存储的值      默认值'' JSON,字符串
     * @ time   类型Number   缓存有效时间（秒）                 默认 1000*60*60*24*7 一周的时间
     * 注：localStorage 方法存储的数据没有时间限制。第二天、第二周或下一年之后，数据依然可用。不能控制缓存时间，故此扩展
     *
     * return  无
     * */
    localStoreSet(key = "", stringVal = "", time = 1000 * 60 * 60 * 24 * 7) {
        try {
            var cacheExpireDate = new Date() - 1 + time;
            var cacheVal = { val: stringVal, exp: cacheExpireDate };
            localStorage.setItem(key, JSON.stringify(cacheVal)); //存入缓存值
            //console.log(key+":存入缓存，"+new Date(cacheExpireDate)+"到期");
        } catch (e) {
            return false;
        }
    }

    /**
     * *** localStoreGet 获取缓存
     * @key  获取的缓存key
     *
     * return value
     * */
    localStoreGet(key) {
        try {
            if (!localStorage) {
                return false;
            }
            var cacheVal = localStorage.getItem(key);
            var result = JSON.parse(cacheVal);
            var now = new Date() - 1;

            if (now > result.exp) {
                //缓存过期
                this.localStoreRemove(key);
                return null;
            }
            return result.val;
        } catch (e) {
            this.localStoreRemove(key);
            return null;
        }
    }

    /**
     * *** remove 移除缓存，一般情况不手动调用，缓存过期自动调用
     * @ key 移除缓存key
     *
     * return  无
     * */
    localStoreRemove(key) {
        try {
            if (!localStorage) {
                return false;
            }
            localStorage.removeItem(key);
        } catch (e) {
            return false;
        }
    }

    /**
     * *** clear 清空所有缓存
     * return  无
     * */
    localStoreClear() {
        try {
            if (!localStorage) {
                return false;
            }
            localStorage.clear();
        } catch (e) {
            return false;
        }
    }

    //计算屏幕密度  返回屏幕密度->正整数 不需要暴露
    initDpr() {
        let dpr = 1;
        dpr = parseInt(
            window.devicePixelRatio ? window.devicePixelRatio : 1
        );
        dpr = dpr < 1 ? 1 : dpr; //如果小于1的情况下, dpr复制为1
        dpr = dpr > 3 ? 3 : dpr; //如果大于3的情况下, dpr复制为3
        dpr = parseInt(dpr) < 2 ? 1 : parseInt(dpr) < 3 ? 2 : 3;
        return parseInt(dpr);
    }

    // 随机字符串  length 小于等于0或者传递的不是数字,返回空字符串 不需要暴露
    randomStr(length) {
        let chars =
            "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"; //使用的字符串
        length = !isNaN(Number(length)) ? Number(length) : 0;
        length = Math.floor(length);
        let result = "";
        if (length <= 0) {
            return result;
        }

        for (var i = length; i > 0; --i) {
            result += chars[Math.floor(Math.random() * chars.length)];
        }
        return result;
    }   


    /** 
     * * isKKApp  判断是否是快看app 运行环境
     * 
     * 参数:无
     * 返回  true(是) | false(不是)   
     * **/
    isKKApp(){
        return /kuaikan\//.test(navigator.userAgent.toLowerCase());
    }

    /** 
     * * returnData 自定义返回数据处理  不需要暴露
     * 
     * @errno 状态码 0:成功  1:失败
     * @msg   提示信息          类型:String   必填项   默认:''
     * @obj   信息其他配置项     类型:Object   选填项   默认:无
     * 
     * 返回:{code ,msg ,obj}
     * **/
    returnData ({code=200400,message="",obj={}}){
        let data={code ,message , data:obj};
        return data;
    }
}


const tools = new TOOLS();

// 导出实例 
export { 
    tools ,  //实例化后的实例
    TOOLS //工具类
};








// WEBPACK FOOTER //
// ./src/assets/js/SDK_copy/libs/sdk.tools.js